import { capitalize, Divider, Paper, Typography } from "@mui/material";
import { FormikTextInput } from "common/components/FormikTextInput";
import { StepProps } from "./StepProps";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

export const NameAndPhotoStep: FC<StepProps> = ({ disabled }) => {
  const { t } = useTranslation();
  return (
    <Paper className="flex w-full gap-2 p-4 justify-between">
      <div className="flex flex-col p-4 gap-2">
        <Typography variant="h6">
          {t("views.autotractor.equipment.tractors.enterNameNoPhoto")}
        </Typography>
        <Divider />
        <FormikTextInput
          disabled={disabled}
          label={capitalize(t("utils.descriptors.name"))}
          name="name"
        />
      </div>
      <div className="flex flex-col gap-2 p-4">
        {/* image uploading disabled for now */}
        {/* <div className="flex mx-auto w-80 h-80 bg-black" />
        <Button disabled={disabled} className="flex mx-auto">
          {t("utils.actions.upload")}
        </Button> */}
      </div>
    </Paper>
  );
};
